export default "__VITE_ASSET__Bh80grr2__"